import { call, put, takeLatest} from "redux-saga/effects"
import { getAddedContactsInfo, getAdminList, getDeletedContactsInfo, getHiddenEntitiesInfo, getMemberActivityInfo, getMemberStatisticsInfo, getStarredEntitiesInfo, updateSalesOwner } from "../../helpers/backend_helper";
import { getAddedContactsList, getAddedContactsListSuccess, getAdminListSuccess, getDeletedContactsListSuccess, getMemberActivityListSuccess, getMemberStatisticsListSuccess, updateSalesOwnerSuccess, getMemberStatisticsList, getStarredEntitiesListSuccess, getHiddenEntitiesListSuccess } from "./actions";
import { GET_ADDED_CONTACTS_INFO, GET_ADMIN_LIST, GET_DELETED_CONTACTS_INFO, GET_HIDDEN_ENTITIES_INFO, GET_MEMBER_ACTIVITY_INFO, GET_MEMBER_STATISTICS_INFO, GET_STARRED_ENTITIES_INFO, UPDATE_SALES_OWNER } from "./actionTypes";

function* onGetMemberStatisticsInfoList({ payload : data }) {
  try {
    const response = yield call(getMemberStatisticsInfo, data);
    yield put(getMemberStatisticsListSuccess(response));
  } catch (error) {
    console.log('onGetMemberStatisticsInfoList error >> ' + error);
  }
}

function* onGetMemberActivityInfoList({ payload : data }) {
  try {
    const response = yield call(getMemberActivityInfo, data);
    yield put(getMemberActivityListSuccess(response));
  } catch (error) {
    console.log('onGetMemberActivityInfoList error >> ' + error);
  }
}

function* onGetAddedContactsInfoList({ payload : data }) {
  try {
    const response = yield call(getAddedContactsInfo, data);
    yield put(getAddedContactsListSuccess(response));
  } catch (error) {
    console.log('onAddedContactsInfoList error >> ' + error);
  }
}

function* onGetDeletedContactsInfoList({ payload : data }) {
  try {
    const response = yield call(getDeletedContactsInfo, data);
    yield put(getDeletedContactsListSuccess(response));
  } catch (error) {
    console.log('onDeletedContactsInfoList error >> ' + error);
  }
}

function* onGetStarredEntitiesLog({ payload : data }) {
  try {
    const response = yield call(getStarredEntitiesInfo, data);
    yield put(getStarredEntitiesListSuccess(response));
  } catch (error) {
    console.log('onGetStarredEntitiesLog error >> ' + error);
  }
}

function* onGetHiddenEntitiesLog({ payload : data }) {
  try {
    const response = yield call(getHiddenEntitiesInfo, data);
    yield put(getHiddenEntitiesListSuccess(response));
  } catch (error) {
    console.log('onGetHiddenEntitiesLog error >> ' + error);
  }
}

function* onGetAdminList({ payload : data }) {
  try {
    const response = yield call(getAdminList, data);
    yield put(getAdminListSuccess(response));
  } catch (error) {
    console.log('onGetAdminList error >> ' + error);
  }
}

function* onUpdateSalesOwner({ payload : data }) {
  try {
    const response = yield call(updateSalesOwner, data.param);
    yield put(updateSalesOwnerSuccess(response));
    yield put(getMemberStatisticsList(data.filter));
  } catch (error) {
    console.log('onUpdateSalesOwner error >> ' + error);
  }
}

function* admMemberStatisticsSaga() {
    yield takeLatest(GET_MEMBER_STATISTICS_INFO, onGetMemberStatisticsInfoList);
    yield takeLatest(GET_MEMBER_ACTIVITY_INFO, onGetMemberActivityInfoList);
    yield takeLatest(GET_ADDED_CONTACTS_INFO, onGetAddedContactsInfoList);
    yield takeLatest(GET_DELETED_CONTACTS_INFO, onGetDeletedContactsInfoList);
    yield takeLatest(GET_STARRED_ENTITIES_INFO, onGetStarredEntitiesLog);
    yield takeLatest(GET_HIDDEN_ENTITIES_INFO, onGetHiddenEntitiesLog);
    yield takeLatest(GET_ADMIN_LIST, onGetAdminList);
    yield takeLatest(UPDATE_SALES_OWNER, onUpdateSalesOwner);
}

export default admMemberStatisticsSaga;